export class SelectedHSchema{
    public SchemaName?: string; 
    public HybridName?: string; 
    public HybridSchemaId?: number; 
    public CommissionSchemaId?: number; 
}

export class TransitSchema{
    public TransitSchemaId?: number
    public SubSchemaId?: number
    public Value?: number
    public TableId?:number
    public CommisionPercent?: number
    public PromotorId?: number
}

export class ValidateSchema{
    public CATEGORIA?: string;
    public SUBESQUEMA?:string;
    public FONDEO?: string;
    public CONVENIO?: string;
    public LINEA?: string;
    public PRODUCTO?: string;
    public COMISION?: number;
    public PLAZO?: string;
    public EMPLEADO?: string;
    public ESQUEMA?: string;
}

export class CreatedSchemas{
    public ESQUEMA: string; 
    public CreateDate: string; 
    public ActiveId: number; 
    public FONDEO: string; 
    public ESTRUCTURA: string; 
    public LINEA: string; 
    public PUESTO: string;
    public SubSchemaHeaderId: number;  
}

export class CatalogModel {
    public id?:number;
    public description?:string;
    public active?:boolean = false;
}
    
export class SaveFinalCommissionSubSchema  {
    public subSchemaHeader?:subSchemaHeader;
    public catOwnerType?: number[];
	public catBusinessProduct?: number[];
	public productosCOE?: number[];
	public catAfiliateHM?: number[];
	public catPaymentTerm?: number[];
	public catEmployeeJob?: number[];
	public catPromoterCategory?: number[];
    public termRate?: number[];
	public subSchemaHeaderId?: number;
	public hybridSchemaId?: number;
    public userId?:number;
}

export class subSchemaHeader  {
    subSchemaHeaderId?:number;	
    name?:string;
    activeId?:number;	
    createDate?:string;
}

export class CatHybridCommissionSchema {
    public createDate?: string;
    public modifDate?: string;
    public modifUserID?: number;
    public userId?: number;
    public hybridName?: string;
    public activeId?: number;
    public hybridSchemaId?: string;
}

export class SaveConfigHybridRequest  {
    public catHybridCommissionSchema?:CatHybridCommissionSchema;
    public schemaIdList?:number[];
}

export class CatBusinessProductModel {
    public businessProductId?:number;
    public businessProductDesc?:string;
}

export class CatAnchorTypeModel {
    public anchorTypeId?:number;
    public anchorTypeDesc?:string;
    public businessProductId?:CatBusinessProductModel;
}

export class CatProductModel {
    public vfinancingTypeId?:string;
    public vfinancingTypeDesc?:string;
    public catBusinessProduct?:CatBusinessProductModel;
    public catAnchorType?:CatAnchorTypeModel;
    public checked?:boolean;
}

export class CatAfiliateModel {
    public approvedName?:string;
    public vafiliateDesc?:string;
    public vafiliateId?:string;
    public catFinancings?:CatProductModel[];
    public checked?:boolean;
}

export class CatPromotionModel {
    public ifinancingId?:number;
    public vfinancingId?:string;
    public CatAfiliate?:CatAfiliateModel;
    public checked?:boolean;
    public exists?:boolean;
}

export class PromotionDTO {
    public catBusinessProduct?:CatBusinessProductModel;
    public catAnchorType?:CatAnchorTypeModel;
    public financingTypes?:Array<CatProductModel>;
    public catAfiliates?:Array<CatAfiliateModel>;
    public checked?:boolean;
}

export class CatSchemaModel {
    public commissionSchemaId?:number;
    public description?:string;
    public tableName?:string;
    public activeId?:boolean;
    public createUserId?:number;
    public createDate?:string;
    public modifUserId?:number;
    public modifDate?:string;
}

export class ConfiguratedSchemaModel {
  public TableId?: number;
  public SubSchemaId?: number;
  public PromotorId?: number;
  public TableName?: string;
  public CommisionPercent?: number;
  public TransitSchemaId?: number;
  public Value?: number;
}

export class CommissionProductEmployeeJobWResult {
  public iCreditId?: number;
  public Linea?: string;
  public Fondeador?: string;
  public Esquema?: string;
  public Producto?: string;
  public Convenio?: string;
  public Empleado?: string;
  public Categoria?: string;
  public Plazo?: string;
  public vEmployeeId?: string;
  public vNombreEmpleado?: string;
  public vFinancingId?: string;
  public FechaCobro?: string;
  public MontoCapitalTotal?: number;
  public CommissionSchema?: number;
  public MontoComisionTotal?: number;
  public Region?: string;
  public Estado?: string;
  public capitalAmount?: number;
  public sucursal: string;
  public ApplyPayment?: number;
  public ComisionApertura?: number;
  public Seguro?: number;
  public executionDate?: string;
  public nCobradoMesAnt?: number;
  public commissionAdjustmentAmount?: number;
  public commissionAmountFinal?: number;
  public MedioAdquisicionId?: number;
  public MedioAdquisicion?: string;
}

export class CommissionAdjustment {
  iCommissionAdjustmentId?: number;
  creditId?: number;
  iCreditIdMotivo?: number;
  employeeId?: string;
  employeeName?: string;
  capitalAmount?: number;
  commissionPercent?: number;
  commissionAmount?: number;
  commissionAdjustmentAmount?: number;
  commissionFinalAmount?: number;
  commissionAdjustmentAvalible?: number;
  commissionAdjustmentFree?: number;
  executionDate?: string;
  createdUserId?: string;
  createdDate?: string;
  simulated?: number;
  businessLineId?: number;
  productId?: number;
  enviado?: number;
  comentario?: string;
  claveEmpleadoDispersion?: string;
}

export class ComisionDispositionResume {
  fechaEjecucion?: string;
  FechaCobro?: string;
  fechaInicio?: string;
  fechaFin?: string;
  sessionId?: string;
  montoTotal?: number;
  Colocacion?: number;
  enviado?: number;
}

export class CommissionDispositionDetail {
  idDispositionGroup?: string;
  vEmployeeId?: string;
  vNombreEmpleado?: string;
  montoColocado?: number;
  comisionTotal?: number;
  ajusteComision?: number;
  comisionFinal?: number;
  userCreate?: number;
  FechaCobro?: string;
  fechaCreacion?: string;
  executionDate?: string;
  ClaveEmpleadoDispersion?: string;
  StatusCane?: string;
  DescripcionCane?: string;
  FechaRecepcionCane?: string;
  StatusCF?: string;
  userSend?: string;
  FechaEnvio?: string;
  enviado?: number;
  sessionId?: string;
  fechaInicio?: string;
  fechaFin?: string;
}

export class CommissionAdjustDisposition {
  idCommissionAdjustDisposition?: number;
  ClaveEmpleadoDispersion?: string;
  comisionTotal?: number;
  ajusteComision?: number;
  comisionFinal?: number;
  userCreate?: number;
  createDate?: string;
  status?: number;
  Nota?: string;
}

export class CommissionCreditAdjustDisposition {
  iCommissionAdjustmentId?: number;
  creditId?: number;
  claveDispersion?: string;
  usuario?: number;
  fechaCreacion?: string;
}

export class BPartner {
  idempleado?: string;
  nombreasesor?: string;
  puestoasesor?: string;
}

export class AdjustPartialRelease {
  iCreditId?: string;
  iCreditIdMotivo?: string;
  EmployeeId?: string;
  EmployeeName?: string;
  CommissionAdjustmentAmount?: string;
  CommissionAdjustmentAvalible?: string;
}

export class CommissionAvalible {
  CommissionAdjustmentAmount1?: number;
  CommissionAdjustmentAvalible?: number;
}